<template>
     <div class="table">
        <div class="container" style="float:right;width:95%;">
            <div style="display: inline-block; height:40px;">
                <el-select v-model="queryForm.deptId" placeholder="请选择学校">
                    <el-option
                        v-for="item in depts"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-input v-model="queryForm.name" placeholder="模板名称" style="width: 150px;" ></el-input>  
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary" plain @click="setAddTemplate">添加模板</el-button>
                <el-button type="danger"  @click="setCopy()">复制</el-button>
            </div>

            <el-table
                :data="dataList"
                v-loading="loading"
                :element-loading-text = "loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                row-key="id"
                border>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column  label="模板名称" :show-overflow-tooltip="true" width="180">
                    <template slot-scope="scope">
                        {{scope.row.name}}（{{ scope.row.dimensionName}}）
                    </template>
                </el-table-column>
                <el-table-column prop="defaultEvaluateIndexName" label="默认评价指标" width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="bindGradeNamestr" label="绑定年段" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column fixed="right" label="操作" width="155px">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setTemplateTask(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">设置任务模板</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button  @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 添加弹出框 -->
        <add-template v-model="addTemplateVisible" :deptId="queryForm.deptId" />
        <!-- 修改弹出框 -->
        <update-template v-model="updateTemplateVisible" :template="selectTemplate" />
        <!-- 设置任务模板弹出框 -->
        <set-template-task v-model="setTemplateTaskVisible" :template="selectTemplate" />
        <!-- 复制弹出框 -->
        <set-Copy v-model="setCopyVisible" :currSchoolId="queryForm.deptId" />
    </div>
</template>

<script>
    import http from '../../../common/http';
    import addTemplate from './components/addTemplate.vue';
    import updateTemplate from './components/updateTemplate.vue';
    import setTemplateTask from './components/setTemplateTask.vue';
    import setCopy from './components/setCopy.vue';

    export default {
        name:"setTemplate",
        data(){
            return{
                loading: false,
                loadingText: "",
                addTemplateVisible:false,
                updateTemplateVisible:false,
                setTemplateTaskVisible:false,
                setCopyVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                },
                queryForm:{
                    deptId: "",
                    name: ''
                },
                form:{
                    id:""
                },
                depts:[],
                dataList:[],
                // 选中的维度/类别
                selectTemplate:{}
            }
        },
        components: {
            addTemplate, updateTemplate, setTemplateTask, setCopy
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.queryForm.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.clockinTemplateListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.queryForm.deptId,
                    name:this.queryForm.name,
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res));
                    if(res.status == 200){
                       this.dataList = res.data.list;
                       this.common.total = res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //添加界面
            setAddTemplate(){
                 this.addTemplateVisible = true
            },
            //修改界面
            setUpdate(data){
                this.selectTemplate = data
                this.updateTemplateVisible = true
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                this.loading=true;
                this.loadingText="数据删除中...";

                let url = this.clockinTemplateRemoveUrl;
                let data = {
                    'id': this.form.id
                };
                // console.log('delBySchoolId',data)
                // return
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            setTemplateTask(data){
                this.selectTemplate = data
                this.setTemplateTaskVisible = true
            },
            setCopy(){
                this.setCopyVisible = true
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>



// WEBPACK FOOTER //
// src/components/page/task/setTemplate.vue